<div class="mobile-nav-footer">
  <nav class="nav">
    <!--home-->
    <h1 [routerLink]="[routerLinkHome]" routerLinkActive="active" class="nav__link ">
      <i class="icon-home"></i>
      <span class="nav__text">{{'label.home' | translate}}</span>
    </h1>

    <!--reward-->
    <h1 [routerLink]="[routerLinkReward]" routerLinkActive="active" class="nav__link ">
      <i class="icon-gift"></i>
      <span class="nav__text">{{'menu.rewards' | translate}}</span>
    </h1>

    <!--my order-->
    <h1 [routerLink]="[routerLinkOrder]" routerLinkActive="active" class="nav__link" [ngClass]="{ 'noti': orderCount }">
      <span class="count" *ngIf="orderCount < 9" [hidden]="orderCount == 0">{{ orderCount }}</span>
      <span class="count" *ngIf="orderCount >= 9">9+</span>
      <i class="icon-order"></i>
      <span class="nav__text">{{'menu.orders' | translate}}</span>
    </h1>

    <!--profile-->
    <h1 [routerLink]="[routerLinkProfile]" routerLinkActive="active" class="nav__link">
      <i class="icon-profile"></i>
      <span class="nav__text">{{'menu.profile' | translate}}</span>
    </h1>
  </nav>
</div>
